export let html: HTMLElement = document.querySelector('html')
export let body: HTMLElement = document.querySelector('body')

export function addStateClass(state: string) {
  html.classList.add(state)
  body.classList.add(state)
}

export function removeStateClass(state: string) {
  html.classList.remove(state)
  body.classList.remove(state)
}

export function rnd(min: number, max: number) {
  return Math.floor((Math.random() * (max - min + 1)) + min)
}

export function addClass(className: string) {
  return this.classList.add(className)
}

export function hasClass(className: string) {
  return this.classList.contains(className)
}

export function removeClass(className: string) {
  return this.classList.remove(className)
}

export function toggleClass(className: string) {
  return this.classList.toggle(className)
}

(function () {
  // @ts-ignore
  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
  }
// @ts-ignore
  CustomEvent.prototype = window.Event.prototype;
// @ts-ignore
  window.CustomEvent = CustomEvent;
})();


export function triggerEvent(el, type: string, params: any = '' ) {

  let e = new CustomEvent(type, {
    detail: {
      extraParameteres: params
    },
    bubbles: true,
    cancelable: false
  })

  el.dispatchEvent(e)

}

// Apply modules

export function applyModule ( selector: string, module, ...args ) {
  const el = document.querySelector(selector)
  if(el) { new module(el, ...args) }
}

export function applyModules ( selector: string, module, ...args ) {
  let els = document.querySelectorAll(selector)
  if(els) { 
    els.forEach(el => { new module(el, ...args) })
  }
}
